import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import packageInfo from "../package.json";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";

import VueRouter from "vue-router";
import Socket from "./mixins/socket";
import axios from "axios";
import VueAxios from "vue-axios";
import VueIziToast from "vue-izitoast"; // notification messages
import "izitoast/dist/css/iziToast.css";
import VueSweetalert2 from "vue-sweetalert2";

import VueSession from "vue-session";
import IdleVue from "idle-vue";
import "babel-polyfill";
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.config.productionTip = false;

const baseTitle = document.title || "Admin";
document.title = `${baseTitle} (${packageInfo.version})`;

// plugin setup
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VueIziToast);
Vue.use(VueSession);
Vue.use(Socket);
Vue.use(VueSweetalert2);

// session time out
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 100
});

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount("#app");
